<div
  class="h-full flex flex-col"
  [class]="floatingPageClasses()"
  [class.justify-between]="!floating()">
  <div
    class="flex flex-wrap items-center justify-between gap-lg"
    [class]="floating() ? 'mb-lg' : 'mb-2xl'">
    <h1 class="text-2xl font-semibold text-neutral-900">
      {{ 'workflow_permission_list_screen_title' | transloco }}
    </h1>
  </div>

  <section
    [class]="floating() ? 'floating-card p-2xl flex flex-col' : 'contents'"
    data-testid="workflow-permission-list-section">
    <ng-template #permissionsSearch>
      <lib-search-field
        class="shrink-0"
        [searchInputWidth]="searchInputWidth"
        [placeholder]="'search_by_name_placeholder'"
        (searchKeywordEmitter)="onSearchTermChange($event)" />
    </ng-template>

    <div
      class="flex items-center justify-between mb-lg gap-lg"
      [class]="floating() ? '' : 'py-lg border-b border-neutral-300'">
      <div class="flex items-center min-w-0">
        @if (!floating()) {
          <p class="text-lg font-semibold text-neutral-900 pe-lg">
            {{ 'workflow_permission_list_screen_sub_title' | transloco }}
          </p>
        }
        <lib-badge
          [label]="totalWorkflowsCount()"
          [badgeClass]="'px-sm border-none text-sm font-medium bg-primary-50 text-primary-700'" />
      </div>

      <!-- Tables_new_design shows the search in the table toolbar instead -->
      @if (!searchInToolbar()) {
        <ng-container [ngTemplateOutlet]="permissionsSearch" />
      }
    </div>

    <div [class.py-lg]="!floating()">
      <lib-table
        [tableClass]="'min-h-[calc(100vh-25rem)] h-auto w-full whitespace-nowrap'"
        [id]="'users'"
        [dataSource]="permissionList()"
        [loading]="isLoading()"
        [columns]="columns()"
        [noDataTitle]="'table_no_data_title' | transloco"
        [noDataDescription]="'section_no_data_description' | transloco"
        [bodyTemplateRef]="[number, name, category, owners, members, action]"
        [tableFilterTabs]="tableFilterTabs()"
        [searchTemplateRef]="searchInToolbar() ? permissionsSearch : null"
        [titleBottomBorder]="false"
        (handleSortColumn)="handleSortColumn($event)"
        (handleViewIconClick)="viewWorkflowDetails($event)">
        <ng-template #number let-row let-i="i">
          {{ (currentPage() - 1) * currentSize() + (i + 1) }}
        </ng-template>

        <ng-template #name let-row>
          <div class="flex items-center gap-md">
            <lib-avatar
              [fullName]="row?.name"
              [img]="row?.icon?.url"
              borderRadius="rounded-full"></lib-avatar>
            <span class="text-xs font-medium text-neutral-900">
              {{ row?.name }}
            </span>
          </div>
        </ng-template>

        <ng-template #category let-row>
          <div class="flex items-center gap-lg">
            <span class="text-xs font-medium text-neutral-900">
              {{ row?.category?.name }}
            </span>
          </div>
        </ng-template>

        <ng-template #owners let-row>
          @if (row.category.owners.length) {
            <lib-user-dropdown-view
              [userCount]="row.category.owners_count"
              [userTableList]="row.category.owners"
              [userDropdownList]="ownerDropdownList()"
              [isDropdownLoading]="isOwnerLoading()"
              [currentDropdownPage]="currentOwnerPage()"
              [totalDropdownPages]="totalOwnerPages()"
              [totalDropdownCount]="totalOwnerCount()"
              [containerRef]="'users'"
              [searchLabel]="'dropdown_search_find_users_label' | transloco"
              [searchPlaceholder]="'search_by_name_placeholder' | transloco"
              [headerListLabel]="
                'dropdown_header_list_owners_label' | transloco
              "
              [noSearchResultLabel]="'no_search_result_label' | transloco"
              (handleMenuToggle)="
                getWorkflowOwnerDropdown($event, row.category.id)
              " />
          }
        </ng-template>

        <ng-template #members let-row
          ><p>{{ row?.members_count }}</p>
        </ng-template>

        <ng-template #action let-row>
          <lib-action-list
            [parentName]="'workflow-permission-table'"
            [menuItems]="getViewActionList(row.id)"
            (itemClick)="actionListItemClick($event, row)"></lib-action-list>
        </ng-template>
      </lib-table>

      @if (permissionList().length) {
        <div [class]="floating() ? 'pt-2xl' : 'py-2xl'">
          <lib-paginator
            [sizeOptionsLabel]="
              'pagination_number_of_rows_per_page_label' | transloco
            "
            [nextBtnLabel]="'pagination_next_button_label' | transloco"
            [previousBtnLabel]="'pagination_previous_button_label' | transloco"
            [currentPage]="currentPage()"
            [totalPages]="totalPages()"
            [totalItems]="+totalWorkflowsCount()"
            [showChangeSize]="true"
            [sizeOptions]="pageSizeOptions"
            (goTo)="handlePagination($event)"
            (next)="handlePagination($event)"
            (previous)="handlePagination($event)"
            (handleChangeSize)="changeSize($event)"
            [currentSize]="currentSize()"></lib-paginator>
        </div>
      }
    </div>
  </section>
</div>
